// VerticalSliderControlView.js

import { View } from 'backbone';
import BaseControlView from 'BaseControlView.js';
import template from 'advanced-inputs/control_horizontal_slider.ejs';
import constants from 'Constants.js';
import eventBus         from 'EventBus.js';

class HorizontalSliderControlView extends BaseControlView {
    initialize(opts){
        super.initialize( opts );
        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_ADVANCED_INPUTS;
        this.icon = 'pf-horizontal-slider';
        this.events = {};

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
        return this;
    }
    get kind() { return 'HorizontalSliderControlView'; }
}

export default HorizontalSliderControlView;